export default function invertObject<T extends Record<PropertyKey, PropertyKey>>(object: T) {
    return (Object.keys(object) as (keyof T)[])
        .reduce<Record<T[keyof T], keyof T>>((result, key) => {
            const value = object[key];

            // eslint-disable-next-line no-param-reassign
            result[value] = key;

            return result;
        }, {} as Record<T[keyof T], keyof T>);
}
